import axios from "axios";
import { API_ENDPOINT, TOKEN_KEY } from "../config";
import { generateURL } from "../utilities";

// const cookies = new Cookies();
const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

/**
 * Export categories with the same filters as the list API.
 * @param {Object} params - Same filter params as category/list (searchQuery, limit). Optionally limit for export size.
 * @returns {Promise<AxiosResponse>} Response with responseType: 'blob' for file download.
 */
export const exportCategory = async (params) => {
  const fd = new FormData();
  const exportParams = { ...params };
  if (exportParams.pageNo !== undefined) delete exportParams.pageNo;
  exportParams.limit = exportParams.limit ?? 9999;
  for (const key in exportParams) {
    if (exportParams.hasOwnProperty(key) && exportParams[key] !== undefined && exportParams[key] !== null) {
      fd.append(key, exportParams[key]);
    }
  }
  const res = await axios({
    method: "post",
    url: `${API_ENDPOINT}category/export${generateURL(exportParams)}`,
    data: fd,
    responseType: "blob",
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
    },
  });
  return res;
};

export const getCategoryList = async (key) => {
  let q = key.queryKey[1];
  // let token = cookies.get(TOKEN_KEY);
  // let res = await q({ method: "GET", url: `${API_ENDPOINT}categorylist`, headers: { Authorization: getToken() ? `Bearer ${getToken()}` : '', } })
  let res = await axios({
    method: "GET",
    url: `${API_ENDPOINT}category/list`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const handleUpdateCategoryStatus = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  const { id, home } = data;
  let fd = new FormData();
  fd.append("id", id);
  fd.append("status", home);
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}categorystatus`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const addCategory = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  for (var key in data) {
    if (Array.isArray(data[key]) || typeof data[key] === "object") {
      fd.append(key, JSON.stringify(data[key]));
    } else {
      fd.append(key, data[key]);
    }
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}categorycreate`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const editCategory = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}categoryupdate`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
export const deleteCategory = async (id) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  fd.append("id", id);
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}categorydelete`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
